import React from 'react';
import { Container, Store, wrap } from 'AppReact';
import { InputError } from 'molecules';
import { UploadButton, UploadedImage } from 'molecules';
import { SectionLabel, Description } from './../../../common/atoms';
import { FieldWrapper } from './../../../common/wrappers';
import { FlexCenterJustifyCenterWrapper, Mt6 } from "wrappers";
import { UploadWrapper, ContainerWrapper, UploadSectionWrapper, MainWrapper, ButtonWrapper } from './wrappers';
import { WebCamBtn } from './atoms';
import { MultiDocSection } from './MultiDocSection';
import { AddSection } from '../../../common/molecules';
import { isAdult } from 'utils';

const screenshotRef = React.createRef();

const CameraIcon = () => <i className="fas fa-camera-retro fa-3x cursor-pointer" />
const WrappedInputError = wrap(InputError, FieldWrapper)

export const definition = {
    name: "Uploads",
    props: {
        optionalDocs: Store,
        screenshotRef,
        language: Store,
        property: Store,
        selectedTabId: Store,
        uploadedDoc: Store,
        toggleWebCam: Store,
        photoIDs: Store,
        occupants: Store
    },
    elements: [
        {
            wrapper: ContainerWrapper,
            name: "Wrapper",
            elements: [
                {
                    component: SectionLabel,
                    name: 'SectionTitle',
                    displayValue: ({ language }) => `${language?.documents || 'Upload Documents'}`,
                    bindings: ({ }) => ({ label: 'Name:', value: '' })
                },
                {
                    component: wrap(Description, FieldWrapper),
                    name: 'Info',
                    displayValue: () => "If you exit the application process before submitting your completed application, you will need to upload your documents again when you continue your application process later.",
                    bindings: ({ }) => ({ label: 'Name:', value: '' })
                },
                {
                    component: wrap(Description, FieldWrapper),
                    name: 'SectionDescription',
                    displayValue: () => "Your pay-stub(s) and driver's license or other form of state-issued ID are required as part of the application process. A photo ID is required for each occupant aged 18 Years and older.",
                    bindings: ({ }) => ({ label: 'Name:', value: '' })
                },
                {
                    wrapper: wrap(MainWrapper, Mt6),
                    name: 'MainWrapper',
                    elements: [

                        {
                            wrapper: UploadSectionWrapper,
                            name: 'PayStubWrapper',
                            elements: [
                                {
                                    wrapper: UploadWrapper,
                                    name: 'PayStubUpload',
                                    elements: [
                                        {
                                            component: UploadButton,
                                            name: 'UploadButton',
                                            displayValue: ({ }) => "Upload doc",
                                            bindings: ({ uploadedDoc }) => ({ uploadedDoc, label: '', text: 'Upload PayStub' })
                                        },
                                        {
                                            component: WebCamBtn,
                                            name: "PayStubWebCamBtn",
                                            renderIf: ({ uploadedDoc }) => !uploadedDoc.payStubUrl,
                                            displayValue: ({ }) => <CameraIcon />,
                                            bindings: () => ({ toggleWebCam: 'payStub' })
                                        },
                                        {
                                            component: UploadedImage,
                                            name: 'UploadedImage',
                                            renderIf: ({ uploadedDoc }) => !!uploadedDoc.payStubUrl,
                                            displayValue: ({ }) => null,
                                            bindings: ({ uploadedDoc }) => ({ uploadedDoc, src: uploadedDoc.payStubUrl || '' })
                                        },
                                    ]
                                },
                                {
                                    component: wrap(WrappedInputError, FlexCenterJustifyCenterWrapper),
                                    name: 'UploadedPayStubError',
                                    bindings: ({ uploadedDoc }) => ({ error: uploadedDoc?.payStubIDError }),
                                    renderIf: ({ uploadedDoc, selectedTabId }) => !!uploadedDoc?.payStubIDError && selectedTabId !== 'review',
                                },
                            ]
                        },
                        {
                            wrapper: UploadSectionWrapper,
                            name: 'PhotoDocsWrapper',
                            elements: [
                                {
                                    component: MultiDocSection,
                                    name: 'PhotoDocs',
                                    isListOf: 'photoIDs',
                                    displayValue: ({ }) => "",
                                    bindings: ({ photoID, photoIDs, photoIDIndex, occupants, selectedTabId }) => {
                                        const adultOccupants = occupants.filter((person) => isAdult(person.dob));
                                        const occupant = adultOccupants.find((_, index) => index === photoIDIndex)
                                        return (
                                            {
                                                selectedTabId,
                                                doc: photoID,
                                                docs: photoIDs,
                                                toggleWebCam: "photoID",
                                                sectionaLabel: "Photo ID",
                                                buttonLabel: `Photo ID for ${occupant?.name?.length ? occupant.name : "occupant" + (photoIDIndex + 1)}`
                                            })
                                    }
                                },
                            ]
                        },
                        {
                            wrapper: UploadSectionWrapper,
                            name: 'OptionalDocWrapper',
                            elements: [
                                {
                                    component: MultiDocSection,
                                    name: 'OptionalDocs',
                                    isListOf: 'optionalDocs',
                                    displayValue: ({ }) => "",
                                    bindings: ({ optionalDoc, optionalDocs, optionalDocIndex, selectedTabId }) => (
                                        {
                                            selectedTabId,
                                            doc: optionalDoc,
                                            docs: optionalDocs,
                                            toggleWebCam: "optional",
                                            sectionaLabel: "Optional Document",
                                            buttonLabel: `Upload #${optionalDocIndex}`
                                        })
                                },
                            ]
                        },
                        {
                            wrapper: ButtonWrapper,
                            name: 'ButtonWrapper',
                            elements: [
                                {
                                    component: AddSection,
                                    name: 'AddOptionalDoc',
                                    isButton: true,
                                    renderIf: ({ selectedTabId }) => selectedTabId !== 'review',
                                    bindings: ({ optionalDocs }) => ({ optionalDocs, label: "Add Document" }),
                                },
                            ]
                        },
                    ]
                },
            ]
        },
    ],
}

const Documents = Container(definition)

export default Documents;



